var _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTitleIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.239 29.8766V25.5533L25.165 16.6606L29.4883 20.9506L20.5623 29.8766H16.239ZM18.3983 27.7173H19.665L23.6667 23.6823L23.0667 23.049L22.4333 22.449L18.3983 26.4506V27.7173ZM2.66666 29.8766V2.66797H16.3827L24.542 10.8273V14.708H21.5087V12.368H14.842V5.7013H5.69999V26.8433H13.5723V29.8766H2.66666ZM23.0667 23.049L22.4333 22.449L23.6667 23.6823L23.0667 23.049Z",
    fill: "url(#paint0_linear_1522_25006)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1522_25006",
    x1: 2.66666,
    y1: 2.66797,
    x2: 29.8725,
    y2: 29.4869,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.224762,
    stopColor: "#00AEED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.852864,
    stopColor: "#1D5AE8"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTitleIcon);
export default __webpack_public_path__ + "static/media/TitleIcon.34d55f39d39d8bd33255bc070f7cf0cf.svg";
export { ForwardRef as ReactComponent };